var themeVars = require("./variables");

module.exports = {

    /**
     * The dimensions of the close button.
     *
     * @returns  {number}  The size of the close button in pixels
     */
    getIconSize: function() {
        return themeVars.getBodyLineHeightPx();
    }

};
